// embedCode.js — ISP-9999 (C7.3): pure URL→embed transform extracted verbatim
// from EmbedURL's inline `getEmbedCode`, so the YouTube / Instagram-Reels /
// passthrough branches can be unit asserted (a mis-edited regex is a real,
// silent break — a raw watch URL iframed instead of the /embed form).
//
// Behaviour-preserving: byte-identical logic to the previous inline function.
//   - YouTube (watch?v= / shorts/ / youtu.be) → https://www.youtube.com/embed/<id>
//   - Instagram Reels (/reel/<id>)            → https://www.instagram.com/reel/<id>/embed
//   - anything else                           → the original url, unchanged

export function getEmbedCode(url) {
  const cleanedUrl = url.replace(
    /<span[^>]*id="mce_marker"[^>]*>.*?<\/span>/g,
    ""
  );

  // Regex for YouTube (including Shorts)
  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^#\&\?]+)/;

  // Regex for Instagram Reels
  const reelsRegex =
    /(?:https?:\/\/)?(?:www\.)?instagram\.com\/reel\/([^#\&\?\/]+)/;

  // Match YouTube URLs
  const youtubeMatch = cleanedUrl.match(youtubeRegex);
  if (youtubeMatch && youtubeMatch[1]) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
  }

  // Match Instagram Reels URLs
  const reelsMatch = cleanedUrl.match(reelsRegex);
  if (reelsMatch && reelsMatch[1]) {
    return `https://www.instagram.com/reel/${reelsMatch[1]}/embed`;
  }

  // Return original URL if no match
  return url;
}
